// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as AcademyMatrixQueries$LiteracyplanetClientSxEntry from "./AcademyMatrixQueries.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";
import * as AcademyParallaxQueries$LiteracyplanetClientSxEntry from "./AcademyParallaxQueries.res.mjs";
import * as AcademyBackgroundQueries$LiteracyplanetClientSxEntry from "./AcademyBackgroundQueries.res.mjs";

function useMatrix(category) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var match = React.useState(function () {
        
      });
  var setMatrix = match[1];
  var matrix = match[0];
  var fetchAgg = AcademyMatrixQueries$LiteracyplanetClientSxEntry.use(userId);
  var mergeMatrix = function (m) {
    setMatrix(function (matrix) {
          return Belt_MapString.reduce(m, matrix, Belt_MapString.set);
        });
  };
  var queryMatrix = async function (category) {
    Belt_Option.map(await fetchAgg(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, category), mergeMatrix);
  };
  React.useEffect((function () {
          if (category !== undefined) {
            queryMatrix(category);
          }
          
        }), [category]);
  var onGetMatrix = function (categoryId) {
    return Belt_Option.getWithDefault(Belt_MapString.get(matrix, AcademyParallaxTypes$LiteracyplanetClientSxEntry.makeMatrixKey(userId, categoryId)), {
                loading: true,
                totalActivityCount: 0
              });
  };
  return [
          onGetMatrix,
          queryMatrix
        ];
}

function AcademyParallaxData$Provider(props) {
  var onPlayActivity = props.onPlayActivity;
  var match = React.useState(function () {
        
      });
  var setCategory = match[1];
  var category = match[0];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setActiveCategoryWindow = match$1[1];
  var match$2 = React.useState(function () {
        return "LEVEL_0";
      });
  var setLevel = match$2[1];
  var currentLevel = match$2[0];
  var match$3 = React.useState(function () {
        return "NoLoading";
      });
  var setLoadNextWindow = match$3[1];
  var returnFromActivityId = React.useRef(props.returnFromActivityId);
  var query = AcademyParallaxQueries$LiteracyplanetClientSxEntry.use(props.md5, "academy", currentLevel, category, returnFromActivityId.current);
  var match$4 = useMatrix(category !== undefined ? (
          category.hasActivities ? undefined : category.id
        ) : (
          query.loading ? undefined : Belt_Array.reduce(query.data, undefined, (function (a, c) {
                    if (typeof c !== "object" || c.TAG !== "Strands") {
                      return a;
                    } else {
                      return Belt_Option.map(Belt_Array.get(c._0, 0), (function (s) {
                                    return s.parentId;
                                  }));
                    }
                  }))
        ));
  var queryMatrix = match$4[1];
  var background = AcademyBackgroundQueries$LiteracyplanetClientSxEntry.use();
  React.useEffect((function () {
          if (query.loading) {
            
          } else {
            setLoadNextWindow(function (param) {
                  return "NoLoading";
                });
          }
        }), [query.loading]);
  var onClickLevel = function (level) {
    setCategory(function (param) {
          
        });
    setLevel(function (param) {
          return level;
        });
  };
  var onClickActivity = function (activity) {
    onPlayActivity(activity.id, activity.title);
  };
  var onClickCategory = function (category, index) {
    var setLoadWindowAndCategory = function (loadWindow) {
      setLoadNextWindow(function (param) {
            return loadWindow;
          });
      setCategory(function (param) {
            return category;
          });
    };
    var last = Belt_Array.get(query.breadcrumb, query.breadcrumb.length - 1 | 0);
    if (last !== undefined && last.id !== category.parentId) {
      if (Belt_Array.some(query.breadcrumb, (function (bc) {
                return bc.id === category.id;
              }))) {
        return setLoadNextWindow(function (param) {
                    return {
                            TAG: "NavigateToWindow",
                            _0: index + 1 | 0
                          };
                  });
      } else {
        return setLoadWindowAndCategory({
                    TAG: "ReplaceExistingWindow",
                    _0: index + 1 | 0
                  });
      }
    } else {
      return setLoadWindowAndCategory({
                  TAG: "LoadNewWindow",
                  _0: index + 1 | 0
                });
    }
  };
  React.useEffect((function () {
          var isReturningFromActivity = function (param) {
            if (category !== undefined) {
              return false;
            }
            var match = returnFromActivityId.current;
            if (match !== undefined) {
              return !query.loading;
            } else {
              return false;
            }
          };
          var updateLevelFromBreadcrumb = function (param) {
            Belt_Option.map(Belt_Option.flatMap(Belt_Array.get(query.breadcrumb, 0), (function (param) {
                        var title = param.title;
                        return Belt_Array.getBy(query.levels, (function (param) {
                                      return param[2] === title;
                                    }));
                      })), (function (param) {
                    var level = param[0];
                    setLevel(function (param) {
                          return level;
                        });
                  }));
          };
          if (isReturningFromActivity()) {
            Promise.all(Belt_Array.map(query.breadcrumb, (function (bc) {
                        if (bc.hasActivities) {
                          return Promise.resolve();
                        } else {
                          return queryMatrix(bc.id);
                        }
                      })));
            updateLevelFromBreadcrumb();
          }
          var id = setTimeout((function () {
                  if (!isReturningFromActivity()) {
                    return ;
                  }
                  var len = query.breadcrumb.length;
                  Belt_Option.map(Belt_Array.get(query.breadcrumb, len - 1 | 0), (function (cat) {
                          onClickCategory(cat, len - 2 | 0);
                        }));
                  returnFromActivityId.current = undefined;
                }), 1000);
          return (function () {
                    clearTimeout(id);
                  });
        }), [
        returnFromActivityId,
        query.loading
      ]);
  var onClickBreadcrumb = function (index) {
    setLoadNextWindow(function (param) {
          return {
                  TAG: "NavigateToWindow",
                  _0: index
                };
        });
  };
  var onActiveCategoryWindowChanged = function (i) {
    setActiveCategoryWindow(function (param) {
          return i;
        });
  };
  return React.createElement(AcademyParallaxTypes$LiteracyplanetClientSxEntry.Provider.make, {
              value: {
                query: query,
                strand: Belt_Array.get(query.breadcrumb, 1),
                background: background,
                currentLevel: currentLevel,
                activeCategoryWindow: match$1[0],
                onGetMatrix: match$4[0],
                onActiveCategoryWindowChanged: onActiveCategoryWindowChanged,
                onClickCategory: onClickCategory,
                onClickBreadcrumb: onClickBreadcrumb,
                onClickActivity: onClickActivity,
                onClickLevel: onClickLevel,
                loadWindow: match$3[0]
              },
              children: props.children
            });
}

var Provider = {
  make: AcademyParallaxData$Provider
};

export {
  useMatrix ,
  Provider ,
}
/* react Not a pure module */
